module.exports = __webpack_public_path__ + "static/instruction2.b90fa346.png";